<script>
    import EditNotesModal from "../../../../../Pages/FollowUp/EditNotesModal.svelte";
    import ViewNotesModal from "../../../../../Pages/FollowUp/ViewNotesModal.svelte";
    import ConvertQuoteOnlyToPatientEncounter from "../../../../../Pages/PatientEncounter/components/ConvertQuoteOnlyToPatientEncounter.svelte";
    import { openViewEncounterSidePanel } from "../../../../../Pages/PatientEncounter/helpers/encounterHelper.svelte";
    import { apiMethods } from "../../../../../Services/index.svelte";
    import { user } from "../../../../../stores";
    import { NoteTypes } from "../../../../../Utils/utilConstants.svelte";

    import {
        goToURL,
        isObjectEmpty,
        showError,
    } from "../../../../../Utils/utilFunctions.svelte";
    import CustomTooltip from "../../../../Common/CustomTooltip.svelte";

    import {
        DateInput,
        NotificationModal,
        TableComponentContainer,
    } from "../../../../Common/index.svelte";

    export let row = {};
    export let isFeeEstimate = false;
    export let actionIconOpenNewTab = false;
    export let isFromCalendarList = false;
    export let saveTableScroll = () => {};
    export let afterModifyNotes = () => {};

    $: encounterOrPatientHasNotes = row?.hasNotes || row?.patient?.hasNotes;

    $: isUserEnableCreateAndEdit = $user.role > 1 && $user.role != 90;

    $: showConvertFeeEstimateToEncounterBtn = isFeeEstimate;
    $: showEditBtn = !row.isDeleted;
    $: showDuplicateBtn =
        ![4, 5].includes(row?.billingStatus) ||
        (row.billingStatus == 4 && isUserEnableCreateAndEdit);

    let isAddNoteModalOpen = false,
        isViewNotesModalOpen = false;

    let convertQuoteToEncounterModalOpen = false;

    const afterSaveNote = async () => {
        saveTableScroll();
        await afterModifyNotes();
    };

    const redirectToEdit = () => {
        saveTableScroll();
        const url = `/${isFeeEstimate ? "PatientQuote" : "PatientEncounter"}/edit/${row.id}`;
        // if (actionIconOpenNewTab)
        //     window.open(`${location.origin}/#${url}`, "_blank");
        if (isFromCalendarList) {
            openViewEncounterSidePanel({
                encounterId: row.id,
                type: "edit",
                onCloseFunction: () => afterModifyNotes(),
            });
        }
        else {
            goToURL(url);
        }
    };

    const redirectToDuplicate = () => {
        saveTableScroll();
        const url = `/${isFeeEstimate ? "PatientQuote" : "PatientEncounter"}/edit/${row.id}/isDuplicate=1`;
        // if (actionIconOpenNewTab)
        //     window.open(`${location.origin}/#${url}`, "_blank");
        if (isFromCalendarList)
            openViewEncounterSidePanel({
                encounterId: row.id,
                type: "duplicate",
                onCloseFunction: () => afterModifyNotes(),
            });
        else goToURL(url);
    };

    // HELPER FUNCTIONS
    export const _openViewNotesModal = () => (isViewNotesModalOpen = true);

    const _openAddNoteModal = () => (isAddNoteModalOpen = true);

    const _openConvertQuoteToEncounterModal = () =>
        (convertQuoteToEncounterModalOpen = true);

    const _closeModifyModal = () => {
        isAddNoteModalOpen = false;
        isViewNotesModalOpen = false;
        convertQuoteToEncounterModalOpen = false;
    };


    let lastNoteContent = null;
    let getFired = false;

    $: noteTooltip = encounterOrPatientHasNotes ? lastNoteContent : "Click here to add a note.";

    const getLastNote = () => {
        if(getFired) return;
        if(lastNoteContent || !encounterOrPatientHasNotes) return;

        getFired = true;
        apiMethods.getMethod
            .getNotes(NoteTypes.PatientEncounter, row.id)
            .then(async (res) => {
                if(res.results.length > 0) {
                    lastNoteContent = res.results[0].content;
                    getFired = false;
                }
            })
            .catch((err) => {
                showError(err);
            });
        
    }
</script>

<TableComponentContainer customContainerClass="min-w-[120px]">
    <div class="flex flex-1 items-center justify-start">
        <div class="flex w-full gap-x-1">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            {#if lastNoteContent}
                <CustomTooltip 
                    zIndex={999}
                    contentClass="max-h-60 overflow-y-auto overflow-x-hidden min-w-0"
                    tooltipPosition="left">
                        <div slot="tooltipTrigger"
                            class="container tooltip tooltip-secondary tooltip-left cursor-pointer flex items-center justify-center w-[30px] h-[30px] text-secondary hover:rounded-full hover:bg-secondary hover:text-white"
                            on:click={encounterOrPatientHasNotes
                                ? () => _openViewNotesModal()
                                : () => _openAddNoteModal()}
                        >
                            {#if !encounterOrPatientHasNotes}
                                <svg
                                    width="14"
                                    height="18"
                                    viewBox="0 0 14 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14 2.36843C14 1.74025 13.7704 1.13796 13.3599 0.693878C12.9503 0.249798 12.3946 0 11.8152 0H5.26917C5.21199 0 5.15396 0.0129524 5.10104 0.0370067C5.04813 0.0601358 5.00033 0.0952912 4.96022 0.139699L0.128018 5.377C0.0469411 5.46674 0.000854271 5.58701 0 5.71284V15.6316C0 16.2598 0.229582 16.862 0.640092 17.3061C1.04975 17.7502 1.60535 18 2.18484 18H11.8152C12.3946 18 12.9503 17.7502 13.3599 17.3061C13.7704 16.862 14 16.2598 14 15.6316V2.36843ZM4.8322 1.61718V3.81816C4.8322 4.6027 4.24588 5.23922 3.5213 5.23922H1.49436L4.8322 1.61718ZM11.8152 17.0527H2.18484C1.46026 17.0527 0.873935 16.4162 0.873935 15.6316V6.18659H3.5213C4.10079 6.18659 4.65724 5.93679 5.0669 5.49271C5.47656 5.04863 5.70614 4.44634 5.70614 3.81816V0.947394H11.8152C12.5397 0.947394 13.1261 1.58391 13.1261 2.36845V15.6316C13.1261 16.4162 12.5397 17.0527 11.8152 17.0527ZM10.4957 13.8802C10.4957 14.0051 10.4496 14.1263 10.3677 14.2151C10.2858 14.3039 10.1748 14.3539 10.0587 14.3539H3.9412C3.69966 14.3539 3.50423 14.1411 3.50423 13.8802C3.50423 13.6184 3.69967 13.4065 3.9412 13.4065H10.0587C10.1748 13.4065 10.2858 13.4565 10.3677 13.5453C10.4496 13.6341 10.4957 13.7544 10.4957 13.8802ZM10.4957 10.9438V10.9429C10.4957 11.0687 10.4496 11.189 10.3677 11.2778C10.2858 11.3666 10.1748 11.4166 10.0587 11.4166H3.9412C3.69966 11.4166 3.50423 11.2047 3.50423 10.9429C3.50423 10.6811 3.69967 10.4692 3.9412 10.4692H10.0587C10.2994 10.4692 10.4949 10.6811 10.4957 10.942L10.4957 10.9438ZM10.4957 8.00744V8.00651C10.4957 8.13233 10.4496 8.25261 10.3677 8.34143C10.2858 8.43025 10.1748 8.4802 10.0587 8.4802H3.9412C3.69966 8.4802 3.50423 8.26834 3.50423 8.00652C3.50423 7.74469 3.69967 7.53283 3.9412 7.53283H10.0587C10.2994 7.53283 10.4949 7.74377 10.4957 8.0056L10.4957 8.00744ZM10.4957 5.07106V5.06921C10.4957 5.19503 10.4496 5.31531 10.3677 5.40413C10.2858 5.49295 10.1748 5.54291 10.0587 5.54291H6.82496C6.58343 5.54291 6.388 5.33104 6.388 5.06922C6.388 4.80831 6.58344 4.59553 6.82496 4.59553H10.0587C10.2994 4.59553 10.4949 4.80647 10.4957 5.06737L10.4957 5.07106Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            {:else}
                                <svg
                                    width="14"
                                    height="18"
                                    viewBox="0 0 14 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M5.24839 3.30635e-05H11.6554C12.3007 3.30635e-05 12.8872 0.292782 13.3114 0.764178C13.7362 1.23557 14 1.88635 14 2.60171V15.3983C14 16.1144 13.7362 16.7652 13.3114 17.2359C12.8866 17.7073 12.3001 18 11.6554 18H2.34456C1.69927 18 1.1128 17.7073 0.688625 17.2359C0.263817 16.7645 0 16.1137 0 15.3983V5.82474C0 5.70636 0.0439673 5.59944 0.114447 5.52268L4.98011 0.123411C5.05382 0.0408982 5.15141 3.30635e-05 5.24839 3.30635e-05ZM7.64009 5.32381C7.42996 5.32381 7.25989 5.13512 7.25989 4.90192C7.25989 4.66872 7.42994 4.48002 7.64009 4.48002H10.0965C10.3066 4.48002 10.4767 4.66872 10.4767 4.90192C10.4767 5.13512 10.3067 5.32381 10.0965 5.32381H7.64009ZM3.90283 8.57054C3.69269 8.57054 3.52263 8.38184 3.52263 8.14864C3.52263 7.91544 3.69267 7.72675 3.90283 7.72675H10.0965C10.3066 7.72675 10.4767 7.91544 10.4767 8.14864C10.4767 8.38184 10.3067 8.57054 10.0965 8.57054H3.90283ZM3.90283 11.8173C3.69269 11.8173 3.52263 11.6286 3.52263 11.3954C3.52263 11.1622 3.69267 10.9735 3.90283 10.9735H10.0965C10.3066 10.9735 10.4767 11.1622 10.4767 11.3954C10.4767 11.6285 10.3067 11.8173 10.0965 11.8173H3.90283ZM3.90283 15.064C3.69269 15.064 3.52263 14.8753 3.52263 14.6421C3.52263 14.4089 3.69267 14.2202 3.90283 14.2202H10.0965C10.3066 14.2202 10.4767 14.4089 10.4767 14.6421C10.4767 14.8753 10.3067 15.064 10.0965 15.064H3.90283ZM1.29644 5.40279H4.86752V1.44008L1.29644 5.40279Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            {/if}
                        </div>
                
                    <p class="m-0 break-words [overflow-wrap:anywhere] hyphens-auto">{@html noteTooltip}</p>
                </CustomTooltip>
            {:else}
                <div
                    class="container tooltip tooltip-secondary tooltip-left cursor-pointer flex items-center justify-center w-[30px] h-[30px] text-secondary hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip={!encounterOrPatientHasNotes
                        ? "Click here to add a note"
                        : "View notes"}
                    on:mouseenter={(e) => getLastNote()}
                    on:click={encounterOrPatientHasNotes
                        ? () => _openViewNotesModal()
                        : () => _openAddNoteModal()}
                    >
                        {#if !encounterOrPatientHasNotes}
                            <svg
                                width="14"
                                height="18"
                                viewBox="0 0 14 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M14 2.36843C14 1.74025 13.7704 1.13796 13.3599 0.693878C12.9503 0.249798 12.3946 0 11.8152 0H5.26917C5.21199 0 5.15396 0.0129524 5.10104 0.0370067C5.04813 0.0601358 5.00033 0.0952912 4.96022 0.139699L0.128018 5.377C0.0469411 5.46674 0.000854271 5.58701 0 5.71284V15.6316C0 16.2598 0.229582 16.862 0.640092 17.3061C1.04975 17.7502 1.60535 18 2.18484 18H11.8152C12.3946 18 12.9503 17.7502 13.3599 17.3061C13.7704 16.862 14 16.2598 14 15.6316V2.36843ZM4.8322 1.61718V3.81816C4.8322 4.6027 4.24588 5.23922 3.5213 5.23922H1.49436L4.8322 1.61718ZM11.8152 17.0527H2.18484C1.46026 17.0527 0.873935 16.4162 0.873935 15.6316V6.18659H3.5213C4.10079 6.18659 4.65724 5.93679 5.0669 5.49271C5.47656 5.04863 5.70614 4.44634 5.70614 3.81816V0.947394H11.8152C12.5397 0.947394 13.1261 1.58391 13.1261 2.36845V15.6316C13.1261 16.4162 12.5397 17.0527 11.8152 17.0527ZM10.4957 13.8802C10.4957 14.0051 10.4496 14.1263 10.3677 14.2151C10.2858 14.3039 10.1748 14.3539 10.0587 14.3539H3.9412C3.69966 14.3539 3.50423 14.1411 3.50423 13.8802C3.50423 13.6184 3.69967 13.4065 3.9412 13.4065H10.0587C10.1748 13.4065 10.2858 13.4565 10.3677 13.5453C10.4496 13.6341 10.4957 13.7544 10.4957 13.8802ZM10.4957 10.9438V10.9429C10.4957 11.0687 10.4496 11.189 10.3677 11.2778C10.2858 11.3666 10.1748 11.4166 10.0587 11.4166H3.9412C3.69966 11.4166 3.50423 11.2047 3.50423 10.9429C3.50423 10.6811 3.69967 10.4692 3.9412 10.4692H10.0587C10.2994 10.4692 10.4949 10.6811 10.4957 10.942L10.4957 10.9438ZM10.4957 8.00744V8.00651C10.4957 8.13233 10.4496 8.25261 10.3677 8.34143C10.2858 8.43025 10.1748 8.4802 10.0587 8.4802H3.9412C3.69966 8.4802 3.50423 8.26834 3.50423 8.00652C3.50423 7.74469 3.69967 7.53283 3.9412 7.53283H10.0587C10.2994 7.53283 10.4949 7.74377 10.4957 8.0056L10.4957 8.00744ZM10.4957 5.07106V5.06921C10.4957 5.19503 10.4496 5.31531 10.3677 5.40413C10.2858 5.49295 10.1748 5.54291 10.0587 5.54291H6.82496C6.58343 5.54291 6.388 5.33104 6.388 5.06922C6.388 4.80831 6.58344 4.59553 6.82496 4.59553H10.0587C10.2994 4.59553 10.4949 4.80647 10.4957 5.06737L10.4957 5.07106Z"
                                    fill="currentColor"
                                />
                            </svg>
                        {:else}
                            <svg
                                width="14"
                                height="18"
                                viewBox="0 0 14 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M5.24839 3.30635e-05H11.6554C12.3007 3.30635e-05 12.8872 0.292782 13.3114 0.764178C13.7362 1.23557 14 1.88635 14 2.60171V15.3983C14 16.1144 13.7362 16.7652 13.3114 17.2359C12.8866 17.7073 12.3001 18 11.6554 18H2.34456C1.69927 18 1.1128 17.7073 0.688625 17.2359C0.263817 16.7645 0 16.1137 0 15.3983V5.82474C0 5.70636 0.0439673 5.59944 0.114447 5.52268L4.98011 0.123411C5.05382 0.0408982 5.15141 3.30635e-05 5.24839 3.30635e-05ZM7.64009 5.32381C7.42996 5.32381 7.25989 5.13512 7.25989 4.90192C7.25989 4.66872 7.42994 4.48002 7.64009 4.48002H10.0965C10.3066 4.48002 10.4767 4.66872 10.4767 4.90192C10.4767 5.13512 10.3067 5.32381 10.0965 5.32381H7.64009ZM3.90283 8.57054C3.69269 8.57054 3.52263 8.38184 3.52263 8.14864C3.52263 7.91544 3.69267 7.72675 3.90283 7.72675H10.0965C10.3066 7.72675 10.4767 7.91544 10.4767 8.14864C10.4767 8.38184 10.3067 8.57054 10.0965 8.57054H3.90283ZM3.90283 11.8173C3.69269 11.8173 3.52263 11.6286 3.52263 11.3954C3.52263 11.1622 3.69267 10.9735 3.90283 10.9735H10.0965C10.3066 10.9735 10.4767 11.1622 10.4767 11.3954C10.4767 11.6285 10.3067 11.8173 10.0965 11.8173H3.90283ZM3.90283 15.064C3.69269 15.064 3.52263 14.8753 3.52263 14.6421C3.52263 14.4089 3.69267 14.2202 3.90283 14.2202H10.0965C10.3066 14.2202 10.4767 14.4089 10.4767 14.6421C10.4767 14.8753 10.3067 15.064 10.0965 15.064H3.90283ZM1.29644 5.40279H4.86752V1.44008L1.29644 5.40279Z"
                                    fill="currentColor"
                                />
                            </svg>
                        {/if}
                    </div>
            {/if}
            {#if showConvertFeeEstimateToEncounterBtn}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="convertQuoteToEncounterIcon container tooltip tooltip-secondary tooltip-left cursor-pointer flex items-center justify-center w-[30px] h-[30px] text-secondary hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Convert Fee Estimate to Encounter"
                    on:click={_openConvertQuoteToEncounterModal}
                >
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="convertQuoteToEncounterIcon"
                    >
                        <path
                            d="M11.5066 17.9922C11.2806 17.9922 11.0712 17.8666 10.9629 17.6744C10.8539 17.4736 10.8539 17.239 10.9708 17.0382L11.8494 15.5735C12.0252 15.2722 12.419 15.1805 12.7116 15.3562C13.0129 15.5319 13.1046 15.9171 12.9289 16.2184L12.703 16.5949C15.0126 16.0505 16.7448 13.9754 16.7448 11.4987C16.7448 11.1551 17.0296 10.8711 17.3724 10.8711C17.716 10.8711 18 11.1551 18 11.4987C17.9922 15.08 15.0801 17.9922 11.5066 17.9922Z"
                            fill="currentColor"
                            class="convertQuoteToEncounterIcon"
                        />
                        <path
                            d="M0.627615 7.11324C0.284787 7.11324 0 6.82846 0 6.48563C0 2.91214 2.91214 0 6.48563 0C6.71157 0 6.92104 0.125523 7.02929 0.318507C7.13834 0.519344 7.13834 0.753138 7.02145 0.953975L6.14279 2.41868C5.96705 2.7113 5.58185 2.81172 5.28059 2.62815C4.98797 2.45242 4.88756 2.06721 5.07112 1.76596L5.29706 1.38939C2.9796 1.93306 1.25522 4.00891 1.25522 6.48563C1.25522 6.82846 0.971227 7.11324 0.627615 7.11324Z"
                            fill="currentColor"
                            class="convertQuoteToEncounterIcon"
                        />
                        <path
                            d="M11.3393 9.52328V11.9835C11.3393 14.0343 10.5187 14.8541 8.46875 14.8541H6.0085C3.95856 14.8541 3.13794 14.0343 3.13794 11.9835V9.52328C3.13794 7.47334 3.95854 6.65352 6.0085 6.65352H8.46875C10.5187 6.65352 11.3393 7.47334 11.3393 9.52328Z"
                            fill="currentColor"
                            class="convertQuoteToEncounterIcon"
                        />
                        <path
                            d="M11.9836 3.13808H9.5233C7.5063 3.13808 6.68648 3.94142 6.66138 5.91686H8.46891C10.9292 5.91686 12.0675 7.06303 12.0675 9.51465V11.3222C14.0508 11.2971 14.8455 10.4773 14.8455 8.46026V6.00864C14.8541 3.9587 14.0335 3.13808 11.9836 3.13808Z"
                            fill="currentColor"
                            class="convertQuoteToEncounterIcon"
                        />
                    </svg>
                </div>
            {/if}
            {#if showEditBtn}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="container tooltip tooltip-secondary tooltip-left cursor-pointer flex items-center justify-center w-[30px] h-[30px] text-secondary hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Edit {isFeeEstimate
                        ? 'Fee Estimate'
                        : 'Patient Encounter'}"
                    on:click={redirectToEdit}
                >
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g clip-path="url(#clip0_4831_5417)">
                            <path
                                d="M8.25 3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V15C1.5 15.3978 1.65804 15.7794 1.93934 16.0607C2.22064 16.342 2.60218 16.5 3 16.5H13.5C13.8978 16.5 14.2794 16.342 14.5607 16.0607C14.842 15.7794 15 15.3978 15 15V9.75"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M13.875 1.87499C14.1734 1.57662 14.578 1.409 15 1.409C15.422 1.409 15.8266 1.57662 16.125 1.87499C16.4234 2.17336 16.591 2.57803 16.591 2.99999C16.591 3.42194 16.4234 3.82662 16.125 4.12499L9 11.25L6 12L6.75 8.99999L13.875 1.87499Z"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </g>
                        <defs>
                            <clipPath id="clip0_4831_5417">
                                <rect width="18" height="18" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            {/if}
            {#if showDuplicateBtn}
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <!-- svelte-ignore a11y-no-static-element-interactions -->
                <div
                    class="container tooltip tooltip-secondary tooltip-left cursor-pointer flex items-center justify-center w-[30px] h-[30px] text-secondary hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Duplicate {isFeeEstimate
                        ? 'Fee Estimate'
                        : 'Patient Encounter'}"
                    on:click={redirectToDuplicate}
                >
                    <svg
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.2857 0.5H6.30755C5.36083 0.5 4.59326 1.26757 4.59326 2.21429V11.1924C4.59326 11.6478 4.77323 12.083 5.09465 12.4053C5.41691 12.7268 5.85219 12.9067 6.30755 12.9067H15.2857C15.7402 12.9067 16.1763 12.7267 16.4977 12.4053C16.8192 12.0831 17 11.6478 17 11.1924V2.21429C17 1.75976 16.8192 1.32367 16.4977 1.00224C16.1763 0.680814 15.7402 0.5 15.2857 0.5ZM6.30755 11.1924V2.21429H15.2857V11.1924H6.30755Z"
                            fill="currentColor"
                        />
                        <path
                            d="M2.21429 17H11.1924C11.6478 17 12.083 16.8192 12.4053 16.4977C12.7268 16.1763 12.9067 15.7402 12.9067 15.2857V14.2143C12.9067 13.7405 12.5233 13.3571 12.0496 13.3571C11.5766 13.3571 11.1924 13.7405 11.1924 14.2143V15.2857H2.21429V6.30755H3.3284C3.80216 6.30755 4.18554 5.92333 4.18554 5.4504C4.18554 4.97664 3.80216 4.59326 3.3284 4.59326H2.21429C1.26757 4.59326 0.5 5.36083 0.5 6.30755V15.2857C0.5 15.7402 0.680803 16.1763 1.00224 16.4977C1.32368 16.8192 1.75979 17 2.21429 17Z"
                            fill="currentColor"
                        />
                    </svg>
                </div>
            {/if}
        </div>
    </div>
</TableComponentContainer>

{#if isAddNoteModalOpen}
    <EditNotesModal
        isModalOpen={isAddNoteModalOpen}
        encounter={row}
        confirmAction={async () => await afterSaveNote()}
        closeModal={_closeModifyModal}
    />
{/if}

{#if isViewNotesModalOpen}
    <ViewNotesModal
        isModalOpen={isViewNotesModalOpen}
        encounter={row}
        closeModal={_closeModifyModal}
        includePatientNotes
        afterModifyNotes={async () => await afterSaveNote()}
    />
{/if}

{#if convertQuoteToEncounterModalOpen}
    <ConvertQuoteOnlyToPatientEncounter 
        isOpen={convertQuoteToEncounterModalOpen}
        isFromCalendarList={isFromCalendarList}
        onClose={_closeModifyModal}
        saveTableScroll={saveTableScroll}
        row={row}>
    </ConvertQuoteOnlyToPatientEncounter>
{/if}

<style>
    .container {
        color: #4a4aff;
        transition:
            background-color 0.3s ease,
            color 0.3s ease;
    }

    .container:hover {
        background-color: #4a4aff;
        color: white;
    }

    svg path {
        transition: fill 0.3s ease;
    }

    .tooltip.tooltip-secondary::before {
        border: none !important;
        box-shadow: 0 1px 4px 0 #00000040 !important;
    }
</style>
